<template>
  <div class="userLog-main-content">
    <div class="search">
      <el-form class="searchForm" :model="searchForm" style="width:640px;">
        <el-form-item>
          <el-input size="small" style="width:300px;" v-model="searchForm.keyword" placeholder="输入订单号、姓名、手机等....">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select clearable size="small" v-model="searchForm.state" placeholder="订单状态">
            <el-option label="未查看" value="1"></el-option>
            <el-option label="处理中" value="2"></el-option>
            <el-option label="已反馈" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" icon="el-icon-bottom" @click="exportAll">导出订单</el-button>
        </el-form-item>
      </el-form>

    </div>
    <div class="table">
      <el-table stripe size="medium" :data="list" highlight-current-row border style="width: 100%;">
        <el-table-column align="center" type="index" width="50"></el-table-column>
        <el-table-column align="center" prop="orderNum" label="订单号" min-width="100"></el-table-column>
        <el-table-column prop="email" label="用户账号" min-width="70"></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="70"></el-table-column>
        <el-table-column prop="country" label="国家" min-width="70"></el-table-column>
        <el-table-column align="center" prop="mobile" label="手机" min-width="80"></el-table-column>
        <el-table-column prop="title" label="订单描述" min-width="140"></el-table-column>
        <el-table-column label="操作时间" align="center" min-width="120">
          <template slot-scope="scope">
            <div>{{ scope.row.createDate | timestampToTime }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.state == 1" type="warning" size="mini" @click="hand(scope.row)" plain>未查看
            </el-button>
            <el-button v-if="scope.row.state == 2" type="primary" size="mini" @click="hand(scope.row)" plain>处理中
            </el-button>
            <el-button v-if="scope.row.state == 3" type="success" size="mini" @click="hand(scope.row)" plain>已反馈
            </el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.$index, scope.row.id)" plain>删除
            </el-button>
          </template>

        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination :params="pageParams" @pageList="pageList"></Pagination>
    </div>

    <el-dialog id="orderDialog" top="5vh" title="订单详情" :visible.sync="orderDetailDialog" width="70%"
      @click="closeOrderDialog">
      <!-- 零件列表 -->
      <div class="user-info">
        配件信息
      </div>
      <el-table size="medium" :data="orderDetailInfo.itemList" highlight-current-row style="width: 100%;">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="carName" label="Car" min-width="100"></el-table-column>
        <el-table-column prop="treeName" label="Part Name" min-width="120"></el-table-column>
        <el-table-column align="center" prop="itemPn" label="PN" min-width="80"></el-table-column>
        <el-table-column prop="itemName" label="Name" min-width="100"></el-table-column>
        <el-table-column align="center" prop="count" label="Count" min-width="80"></el-table-column>
      </el-table>
      <!-- 用户信息 -->
      <div class="user-info">
        用户信息
      </div>
      <el-form label-width="180px" :model="orderDetailInfo.order">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="姓名">
              <el-input type="text" size="small" disabled style="width:80%" v-model="orderDetailInfo.order.name"
                class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="邮箱">
              <el-input type="text" size="small" disabled style="width:80%" v-model="orderDetailInfo.order.email"
                class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="手机">
              <el-input type="text" size="small" disabled style="width:80%" v-model="orderDetailInfo.order.mobile"
                class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="国家">
              <el-input type="text" size="small" disabled style="width:80%" v-model="orderDetailInfo.order.country"
                class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="公司">
              <el-input type="text" size="small" disabled style="width:80%" v-model="orderDetailInfo.order.company"
                class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="地址">
              <el-input type="text" size="small" disabled style="width:80%" v-model="orderDetailInfo.order.address"
                class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="备注">
              <el-input type="textarea" size="small" disabled style="width:80%" v-model="orderDetailInfo.order.remark"
                class="form-input">
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <!-- 用户信息 -->
      <div class="user-info">
        订单处理
      </div>
      <el-form label-width="120px" :model="orderDetailInfo.order">
        <el-row>
          <el-col :span="11">
            <el-form-item label="当前订单状态">
              <el-input type="text" size="small" disabled style="width:80%"
                :value="orderDetailInfo.order.state === 1 ? '待处理' : orderDetailInfo.order.state === 2 ? '处理中' : '已反馈'"
                class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>

          <el-col :span="12">
            <el-form-item label="上传报价单" prop="priceUrl" v-if="!fileList || fileList.length == 0">
              <el-upload class="upload-demo" :limit="1" drag action="https://epc.yiec.com/apiNQ/api/common/upload"
                :before-upload="beforeBookUpload" :on-success="uploadBookSuccess" :file-list="fileList">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处(只能上传excel文件)，或<em>点击上传</em></div>
              </el-upload>
            </el-form-item>
            <el-form-item label="报价单" prop="priceUrl" v-else>
              <span>{{ orderDetailInfo.order.priceFileName }}</span>
              <div class="priceFile">
                <el-button size="small" type="success" @click="downPrice(orderDetailInfo.order.priceUrl)" plain>下载报价单
                </el-button>
                <el-button size="small" type="primary" @click="uploadPriceNew" plain>重新上传</el-button>
              </div>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="回复">
              <el-input rows="6" type="textarea" size="small" style="width:80%" v-model="orderDetailInfo.order.reply"
                class="form-input">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-button style="margin-left:160px;" size="small" icon="el-icon-bottom" type="success"
        @click="exportSingle(orderDetailInfo.order.id)">导出该订单</el-button>
      <el-button style="margin-left:10px;" size="small" type="primary" @click="successPriceUrl">确认提交</el-button>
      <el-button style="margin-left:10px;" size="small" type="info" @click="closeOrderDialog">取消</el-button>
    </el-dialog>

  </div>
</template>

<script>
import { user_refresh_token, order_page, order_click_and_get, order_set_price, order_export, order_export_single, order_del } from "../api/api";
import './../assets/css/userLog.css';
import Pagination from "../components/Pagination";

export default {
  data() {
    return {
      timer: null, // 定时器
      orderDetailDialog: false,
      // 搜索表单
      searchForm: {
        keyword: '',
        state: ''
      },
      // 分页表单
      pageParams: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 列表
      list: [],
      fileList: [],
      orderDetailInfo: {
        itemList: [],
        order: {
          id: '',
          email: '',
          state: '',
          name: '',
          mobile: '',
          company: '',
          address: '',
          country: '',
          remark: '',
          priceUrl: '',
          priceFileName: '',
          reply: ''
        }
      },
    };
  },
  // 注册组件
  components: { Pagination },

  created() {
    // 定时器 start
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    // 定时器 end

    this.page(this.pageParams.currentPage, this.pageParams.pageSize);
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    // 定时器
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.refreshToken()
        }, 10 * 60 * 1000)
      }
    },
    async refreshToken() {
      let param = { "page": "userlog", "token": window.localStorage.getItem("user") }
      const data = await user_refresh_token(param);
      window.localStorage.setItem("user", data.data);
    },

    // ----------------------search start---------------------
    search() {
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },
    async exportAll() {
      // 查询
      const param = {};
      param.keyword = this.searchForm.keyword;
      if (this.searchForm.state) {
        param.state = this.searchForm.state;
      }
      await order_export(param).then(res => {
        if (res.code == 1) {
          window.location.href = res.data
        }
      })

    },
    // 分页插件事件
    pageList(currentPage, pageSize) {
      this.page(currentPage, pageSize);
    },
    // 分页查询
    async page(currentPage, pageSize) {
      // 查询
      const param = {};
      param.currentPage = currentPage;
      param.pageSize = pageSize;

      param.keyword = this.searchForm.keyword;
      if (this.searchForm.state) {
        param.state = this.searchForm.state;
      }

      const data = await order_page(param);

      this.pageParams.total = data.data.total;
      this.pageParams.pageSize = data.data.pageSize;
      this.pageParams.currentPage = data.data.currentPage;
      this.list = data.data.list;

      if (this.pageParams.total > 0 && this.pageParams.total == (this.pageParams.currentPage - 1) * this.pageParams.pageSize) {
        this.page(this.pageParams.currentPage - 1, this.pageParams.pageSize);
      } else {
        this.list = data.data.list;
      }
    },
    // ----------------------search end---------------------
    hand(row) {
      this.orderDetailDialog = true;
      this.clickOrder(row.id);
    },
    closeOrderDialog() {
      this.orderDetailDialog = false;
      this.orderDetailInfo.itemList = [];
      this.orderDetailInfo.order.id = '';
      this.orderDetailInfo.order.email = '';
      this.orderDetailInfo.order.state = '';
      this.orderDetailInfo.order.name = '';
      this.orderDetailInfo.order.mobile = '';
      this.orderDetailInfo.order.company = '';
      this.orderDetailInfo.order.address = '';
      this.orderDetailInfo.order.country = '';
      this.orderDetailInfo.order.remark = '';
      this.orderDetailInfo.order.priceUrl = '';
      this.orderDetailInfo.order.priceFileName = '';
      this.orderDetailInfo.order.reply = '';
      this.fileList = [];
    },
    async clickOrder(id) {
      await order_click_and_get(id).then(res => {
        if (res.code == 1) {
          this.orderDetailInfo = res.data;
          if (this.orderDetailInfo.order.priceUrl && this.orderDetailInfo.order.priceFileName) {
            this.fileList = [{ name: this.orderDetailInfo.order.priceFileName, url: this.orderDetailInfo.order.priceUrl }]
          }
        }
      })
    },
    downPrice(url) {
      window.location.href = url;
    },
    uploadPriceNew() {
      this.fileList = [];
    },

    beforeBookUpload(file) {
      // ".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      // 判断是否是excel
      const isExcel = (file.type.indexOf('csv') != -1 || file.type.indexOf('vnd.ms-excel') != -1 || file.type.indexOf('vnd.openxmlformats-officedocument') != -1)
      const isLt10M = file.size / 1024 / 1024 <= 10;

      if (!isExcel) {
        this.$message.error('上传文件只能是excel文件!');
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过10M!');
      }
      return isExcel && isLt10M;
    },
    uploadBookSuccess(res, file) {
      URL.createObjectURL(file.raw);
      this.orderDetailInfo.order.priceUrl = res.data;
      this.orderDetailInfo.order.priceFileName = file.name;
    },
    async updatePriceUrl(id, url, fileName, reply) {
      let param = { priceUrl: url, id: id, priceFileName: fileName, reply: reply }
      await order_set_price(param).then(res => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "Success!"
          });
          // this.closeOrderDialog();
        }
      });
    },
    successPriceUrl() {
      this.updatePriceUrl(this.orderDetailInfo.order.id, this.orderDetailInfo.order.priceUrl, this.orderDetailInfo.order.priceFileName, this.orderDetailInfo.order.reply)
      this.closeOrderDialog();
    },
    async exportSingle(orderId) {
      await order_export_single(orderId).then(res => {
        if (res.code == 1) {
          window.location.href = res.data;
          this.closeOrderDialog();
        }
      })
    },

    // ----------------------delete start-------------------
    // 删除记录
    handleDelete(index, id) {
      this.delConfirm(index, id);
    },
    //删除确认对话框
    delConfirm(index, id) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          order_del(id).then(res => {
            if (res.code === 1) {
              // 刷新页面请求
              this.list.splice(index, 1);
              this.page(this.pageParams.currentPage, this.pageParams.pageSize);
            } else {
              this.$message({
                type: "success",
                message: "删除失败!"
              });
            }
          });

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // ----------------------delete end---------------------


  }
};
</script>
<style>
#orderDialog .el-dialog__body {
  padding-top: 0px;
  padding-bottom: 20px;
}

#orderDialog .el-dialog {
  min-height: 80vh;
  max-height: 95vh;
}

.user-info {
  margin-top: 16px;
  margin-bottom: 16px;
  padding-left: 20px;
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  background-color: #F5F7FA;
  border-left: 4px solid #C0C4CC;
}

.priceFile {
  display: flex;
}
</style>





// WEBPACK FOOTER //
// src/views/Order.vue